// extracted by mini-css-extract-plugin
export default {"box":"orderFilterPage_box__WlfLF","box__content":"orderFilterPage_box__content__lDni0"};